/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  createDualhookSession() {
    return axios.post(`${this.baseUrl()}/whatsapp/dualhook/session`);
  }

  finalizeDualhook({ sessionId }) {
    return axios.post(`${this.baseUrl()}/whatsapp/dualhook/finalize`, {
      session_id: sessionId,
    });
  }
}

export default new WhatsappChannel();
